import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
//import {NgSpinningPreloader} from 'ng2-spinning-preloader';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
export class AppComponent {
  title = 'app';
  isParaActive = false;
  isBtnActive = false;

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('es');
  }

  ngOnInit() {
    if (localStorage.getItem('version') !== '5.0.0') {
      localStorage.setItem('version', '5.0.0');
      window.location.reload();  
    }
  }

  toggleClass() {
    this.isParaActive = !this.isParaActive;
    this.isBtnActive = !this.isBtnActive;
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts